import {createFetchListReducer} from 'common/reducers/utils';

const defaultReducer = createFetchListReducer({
  name: 'region',
  keys: ['agencyId'],
});

export default function region(state = {
  isFetching: false,
  items: {},
}, action) {
  return defaultReducer(state, action);
}



// WEBPACK FOOTER //
// ./src/ondemand/reducers/region.js